import React, { useState } from "react";


const GPPayment = () => {
    const [activeTab, setActiveTab] = useState("");

    const tabs = ["Pending Payments", "Escrow","Payment History"];



    const renderTabContent = () => {
        switch (activeTab) {
            
            default:
                
        }
    };

    return (
        <div className="buyer-layout">
            
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="mb-3 main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${
                                        activeTab === tab
                                            ? "active"
                                            : "notactive"
                                    }`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default GPPayment;